import type { SpotlightRect } from '../../../../shared/ui/common/WorkspaceSpotlightTour';

// Fallback rects are last-resort spotlights for when the real target cannot
// be measured yet (panel closed, list empty, late mount). They approximate
// the current layout: 34px host ribbon (Revit add-in only), then the export
// command bar (~48px) with its right-aligned command cluster, and the table
// below. The right-edge offsets walk the command cluster from its end:
// Export all, Pick in Revit, export log, settings, columns, row highlight,
// visual check, refresh.

export const getHeaderFallbackRect = (): SpotlightRect => ({
  top: 34,
  left: 24,
  width: Math.max(window.innerWidth - 48, 360),
  height: 48,
});

export const getRefreshButtonFallbackRect = (): SpotlightRect => ({
  top: 48,
  left: Math.max(window.innerWidth - 470, 24),
  width: 34,
  height: 34,
});

export const getVisualCheckButtonFallbackRect = (): SpotlightRect => ({
  top: 48,
  left: Math.max(window.innerWidth - 428, 24),
  width: 34,
  height: 34,
});

export const getSystemCountFallbackRect = (): SpotlightRect => ({
  top: 52,
  left: 150,
  width: 180,
  height: 24,
});

export const getSystemTableToolsFallbackRect = (): SpotlightRect => ({
  top: 140,
  left: 24,
  width: Math.max(window.innerWidth - 48, 360),
  height: 48,
});

export const getSystemTableFallbackRect = (): SpotlightRect => ({
  top: 180,
  left: 24,
  width: Math.max(window.innerWidth - 48, 360),
  height: Math.max(window.innerHeight - 220, 220),
});

export const getSystemRowFallbackRect = (): SpotlightRect => ({
  top: 180,
  left: 24,
  width: Math.max(window.innerWidth - 48, 360),
  height: Math.max(window.innerHeight - 220, 220),
});

export const getFirstRowFallbackRect = (): SpotlightRect => ({
  top: 186,
  left: 32,
  width: Math.max(window.innerWidth - 48, 360),
  height: 44,
});

export const getRowHighlightButtonFallbackRect = (): SpotlightRect => ({
  top: 48,
  left: Math.max(window.innerWidth - 386, 24),
  width: 34,
  height: 34,
});

export const getColumnPanelFallbackRect = (): SpotlightRect => ({
  top: 140,
  left: Math.max(window.innerWidth - 376, 24),
  width: 352,
  height: Math.max(window.innerHeight - 180, 260),
});

export const getColumnSearchFallbackRect = (): SpotlightRect => ({
  top: 164,
  left: Math.max(window.innerWidth - 340, 32),
  width: 300,
  height: 48,
});

export const getManageColumnsButtonFallbackRect = (): SpotlightRect => ({
  top: 48,
  left: Math.max(window.innerWidth - 344, 24),
  width: 34,
  height: 34,
});

export const getExportSettingsButtonFallbackRect = (): SpotlightRect => ({
  top: 48,
  left: Math.max(window.innerWidth - 302, 24),
  width: 34,
  height: 34,
});

export const getExportSettingsDialogFallbackRect = (): SpotlightRect => ({
  top: 120,
  left: Math.max((window.innerWidth - 520) / 2, 24),
  width: 500,
  height: 420,
});

export const getSettingsGroupingFallbackRect = (): SpotlightRect => ({
  top: 172,
  left: Math.max((window.innerWidth - 500) / 2, 24),
  width: 460,
  height: 130,
});

export const getOutputPathFallbackRect = (): SpotlightRect => ({
  top: 48,
  left: Math.max(window.innerWidth * 0.32, 160),
  width: Math.max(window.innerWidth * 0.28, 220),
  height: 34,
});

export const getSettingsValidationFallbackRect = (): SpotlightRect => ({
  top: 430,
  left: Math.max((window.innerWidth - 500) / 2, 24),
  width: 460,
  height: 88,
});

export const getSelectionSummaryFallbackRect = (): SpotlightRect => ({
  top: 102,
  left: 24,
  width: Math.max(window.innerWidth * 0.3, 280),
  height: 36,
});

export const getExportButtonFallbackRect = (): SpotlightRect => ({
  top: 48,
  left: Math.max(window.innerWidth - 112, 24),
  width: 96,
  height: 32,
});

export const getPickAndExportButtonFallbackRect = (): SpotlightRect => ({
  top: 48,
  left: Math.max(window.innerWidth - 218, 24),
  width: 110,
  height: 32,
});
